// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-wrapper[data-v-7064e1c2]{display:block}.info-horizontal[data-v-7064e1c2]  .icon,.info[data-v-7064e1c2]  .info-title{margin-top:0}.md-theme-default h3.md-display-2[data-v-7064e1c2]{color:#42b983;font-size:1.5625rem}", ""]);
// Exports
module.exports = exports;
